import React, { useState, useEffect, useRef } from 'react';
import { iniciarCaptchaAfip } from './captcha';

function Form({ onData, onClear }) {
  const [cuit, setCuit] = useState('');
  const [solucion, setSolucion] = useState('');
  const [img, setImg] = useState('');
  const [token, setToken] = useState('');
  const [captchaStatus, setCaptchaStatus] = useState({
    captchaError: '',
    loadCaptchaError: '',
  });
  const canvasRef = useRef(null);

  const cargarCaptcha = async () => {
    try {
      const respuesta = await iniciarCaptchaAfip();
      setImg(respuesta.image);
      setToken(respuesta.token);
      setSolucion('');
      setCaptchaStatus({ captchaError: '', loadCaptchaError: '' });
    } catch (error) {
      console.error('Error cargando captcha:', error);
      setCaptchaStatus((prev) => ({
        ...prev,
        loadCaptchaError: 'Error cargando el captcha, intenta nuevamente.'
      }));
    }
  };


  useEffect(() => {
    cargarCaptcha();
  }, []);

  useEffect(() => {
    if (img && canvasRef.current) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      const image = new Image();
      image.src = img;
      image.onload = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(image, 0, 0, 300, 60);        
      };
    }
  }, [img]);

  const verificarCaptcha = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`/api/Registro/obtenerRegistrosVerificado/${cuit}`, {
        // const response = await fetch(`${import.meta.env.VITE_API_URL}/api/Registro/obtenerRegistrosVerificado/${cuit}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ Solution: solucion, Token: token }),
      });

      if (!response.ok) {
        let errorMsg = '';
        if (response.status === 401) {
          errorMsg = 'Captcha inválido. Por favor, refrescá el captcha y probá de nuevo.';
        } else if (response.status === 404) {
          onClear(); // limpiar registros cuando no se encontraron datos
          errorMsg = 'No se encontraron registros para el CUIT ingresado.';
        } else if (response.status === 500) {
          errorMsg = 'Ocurrió un error interno. Intentá más tarde.';
        } else {
          errorMsg = 'Error inesperado. Por favor, intentá de nuevo.';
        }
        setCaptchaStatus((prev) => ({ ...prev, captchaError: errorMsg }));
        return;
      }
      const data = await response.json();
      onData(data);
      limpiarFormulario();
    } catch (error) {
      console.error('Error verificando captcha:', error);
      setCaptchaStatus((prev) => ({ ...prev, captchaError: 'Error inesperado' }));
    }
  };

  const limpiarFormulario = () => {
    setSolucion('');
    setCuit('');
    cargarCaptcha();
  };

  return (
    <div className="col-xs-12 col-md-6 col-md-offset-3">
      <h3 className="h2 bold m-b-2 m-t-1">Registro de contribuyentes</h3>
      <div className="panel panel-default p-a-2">
        <form id="captcha-form" onSubmit={verificarCaptcha}>
          <div className="form-group">
            <label htmlFor="cuit" className="control-label">
              Por favor, ingresá el CUIT
            </label>
            <input
              type="text"
              maxLength="11"
              className="form-control"
              id="cuit"
              name="cuit"
              pattern="^\d{11}$"
              value={cuit}
              onChange={(e) => {
                // Reemplaza cualquier carácter que no sea dígito
                const sanitizedValue = e.target.value.replace(/\D/g, '');
                setCuit(sanitizedValue);
              }}
              placeholder="Ingresá los 11 dígitos, sin puntos ni guiones"
              required
            />
          </div>
          <div className="form-group d-flex align-items-center flex-wrap">
            <canvas
              ref={canvasRef}
              id="captcha"
              width="300"
              height="60"
              className="border-1 captcha-img"
              style={{ marginRight: '5px' }}
            ></canvas>
            {captchaStatus.loadCaptchaError && (
              <div className="alert alert-danger" role="alert">
                {captchaStatus.loadCaptchaError}
              </div>)}
            <button
              type="button"
              className="btn btn-info"
              id="refresh-captcha"
              title="Refrescar captcha"
              onClick={cargarCaptcha}
            >
              <i className="fa fa-refresh"></i>
            </button>
          </div>
          {captchaStatus.captchaError && (
            <div className="alert alert-danger" role="alert">
              {captchaStatus.captchaError}
            </div>
          )}
          <div className="form-group">
            <label htmlFor="captcha-input" className="control-label">
              Completá el captcha
            </label>
            <input
              type="text"
              className="form-control"
              id="captcha-input"
              placeholder="Ingresá el código alfanumérico"
              value={solucion}
              onChange={(e) => setSolucion(e.target.value)}
              required
            />
            <span className="help-block hidden"></span>
          </div>
          <button
            type="button"
            className="btn btn-primary-outline"
            onClick={() => {
              onClear();
              limpiarFormulario();
            }}
          >
            Limpiar
          </button>
          &nbsp;
          <button type="submit" className="btn btn-primary" >
            Consultar
          </button>
        </form>
      </div>
    </div>
  );
}

export default Form;
